export default __webpack_public_path__ + "static/media/flow-logo.b919aa35.png";